module.exports = __webpack_public_path__ + "img/2.d7a28d24.png";